const initialProps = {
  rolEnviroment: {},
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "UPDATE_STATE_ROL_ENVIROMENT":
      return {
        ...state,
        rolEnviroment: action.payload,
      };
    default:
      return state;
  }
}
